<template>
  <div :class="{ active: show }" class="modal">
    <div v-if="groupAdvancedSettingsModalConfig">
      <div class="warning">
        <Warning />
      </div>

      <span v-html="groupAdvancedSettingsModalConfig.text"></span>

      <div class="buttons">
        <button @click="closeModal">{{ parseTranslation(NO) }}</button>
        <button @click="emitEvent">{{ parseTranslation(YES) }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Warning from '@/components/imgs/Warning'

import * as translationAddPartner from '@/pages/AdminUser/UserList.translations'

const { default: translations, ...translationKeys } = translationAddPartner

export default {
  components: { Warning },

  data() {
    return {
      translations,
      ...translationKeys,
      show: false,
    }
  },

  computed: {
    groupAdvancedSettingsModalConfig() {
      return this.$store.getters.modalGroupsAdvancedSettings
    },
  },

  watch: {
    groupAdvancedSettingsModalConfig() {
      if (this.groupAdvancedSettingsModalConfig) {
        this.openModal()
      }
    },
  },

  methods: {
    ...mapActions(['setGroupAdvancedSettingsModalConfig']),

    openModal() {
      this.show = true
    },

    emitEvent() {
      this.groupAdvancedSettingsModalConfig.confirmationCallback()

      this.closeModal()
    },

    closeModal() {
      this.show = false
      this.setGroupAdvancedSettingsModalConfig(null)
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  @include background-modal-config;

  &.active {
    display: flex;
  }

  > div {
    @include modal-config(600);
    line-height: 18px;
    text-align: center;

    .warning {
      margin-bottom: 10px;
      svg {
        @include boxSizing(40);
      }
    }

    .buttons {
      margin-top: 30px;

      button {
        @include modal-buttons;
      }
    }
  }
}
</style>
